export default __webpack_public_path__ + "static/media/browns_black.78d598ad.png";